const SELECTORS = {
	input: '#verification-code',
	button: '.enable-two-factor-button',
};

const CLASSES = {
	disabled: 'disabled',
};

export class VerificationCode {
	constructor() {
		this.input = document.querySelector(SELECTORS.input);
		this.button = document.querySelector(SELECTORS.button);

		// Check if required elements exist
		if (!this.input || !this.button) {
			return;
		}

		this.bindEvents();
		this.setup();
	}

	static init() {
		// eslint-disable-next-line
		new VerificationCode();
	}

	bindEvents() {
		['handleInput', 'handleKeyPress'].forEach((e) => {
			this[e] = this[e].bind(this);
		});
	}

	handleInput({ target: { value } }) {
		this.validateInput(value);
	}

	handleKeyPress(event) {
		// Only allow numeric input
		const char = String.fromCharCode(event.which);
		if (!/[0-9]/.test(char) && event.which !== 8 && event.which !== 46) {
			event.preventDefault();
		}
		// This method is bound to this instance to prevent non-numeric input
		return this;
	}

	validateInput(value) {
		// Check if input has exactly 6 numeric characters
		const isValid = /^[0-9]{6}$/.test(value);

		if (isValid) {
			this.enableButton();
		} else {
			this.disableButton();
		}
	}

	enableButton() {
		this.button.disabled = false;
		this.button.classList.remove(CLASSES.disabled);
	}

	disableButton() {
		this.button.disabled = true;
		this.button.classList.add(CLASSES.disabled);
	}

	setupEventListeners() {
		this.input.addEventListener('input', this.handleInput);
		this.input.addEventListener('keypress', this.handleKeyPress);
	}

	setup() {
		this.setupEventListeners();
		// Initially disable the button
		this.disableButton();
	}

	destroy() {
		if (this.input) {
			this.input.removeEventListener('input', this.handleInput);
			this.input.removeEventListener('keypress', this.handleKeyPress);
		}
	}
}
